"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var IndustryResource = /** @class */ (function (_super) {
    tslib_1.__extends(IndustryResource, _super);
    function IndustryResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IndustryResource.endpoint = '/industries';
    IndustryResource.MODEL_NAME = 'industry';
    return IndustryResource;
}(base_1.default));
exports.default = IndustryResource;
//# sourceMappingURL=industry.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/industry.js
// module id = rx8k
// module chunks = 0